module.exports = __webpack_public_path__ + "media/images/icon-notice-unread-d50f83665cb961dfad2d1cd20cb9ca42.svg";